/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { registerCommands } from "./Commands";

export function DebugToolsModule(dc: IEditor): void {
	dc.get("logger").debug("DebugTools module enabled.");

	registerCommands(dc);
}
